export function data(page: number, size: number, total: number): Core.PagingData {
    const start = (size * page) - size + 1;
    const stop = (start + size - 1) > total ? total : (start + size - 1);
    return {start, stop, total, size, page};
}
